import styled from '@emotion/styled';
import StyledThumbnailImage from '../StyledThumbnailImage';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

const TinyThumbnailAsLoadingPlaceholder = styled(StyledThumbnailImage)(
  {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backdropFilter: 'blur(2px)',
    },
    '.MuiCircularProgress-root': {
      padding: 8,
      color: 'rgba(255, 255, 255, 0.7)',
      backgroundColor: 'rgba(0, 0, 0, .6)',
      borderRadius: '50%',
      zIndex: 1,
    },
  },
  addHighContrastStyles({
    '.MuiCircularProgress-root': {
      color: 'white',
      backgroundColor: 'black',
    },
  }),
);

export default TinyThumbnailAsLoadingPlaceholder;
